import React, {useState, useEffect} from 'react';
import {i_attach} from "../../icons";

export function FilePreview({path, file}) {
  const [error, setError] = useState(false);
  const [isImage, setIsImage] = useState(false);

  useEffect(() => {
    setIsImage(file ? ['jpg', 'jpeg', 'png', 'webp'].indexOf(file.toLowerCase().split('.').pop()) > -1 : false);
    setError(false);
  }, [file]);

  return <p className="chat__message--file">
    <a href={path + file} target="_blank" rel="noreferrer" className="attached--icon">
      {!error && isImage && <img src={path + file} alt={file} onError={() => setError(true)} onLoad={() => setError(false)} />}
      {(error || !isImage) && <span>{i_attach()} {file}</span>}
    </a>
  </p>;
}
